import { Navigate } from 'react-router-dom';
import { isAuthenticated, getCurrentUser } from '../utils/api';

export const ProtectedRoute = ({ children, requireSuperAdmin = false }) => {
  const authenticated = isAuthenticated();
  const user = getCurrentUser();

  if (!authenticated) {
    return <Navigate to="/login" replace />;
  }

  // Check for super admin access if required
  if (requireSuperAdmin && user?.role !== 'super_admin') {
    return <Navigate to="/dashboard" replace />;
  }

  // Managers need to be assigned to at least one company
  // Support both old (company_id) and new (company_ids) format
  if (user?.role === 'manager') {
    const hasCompany = user?.company_ids?.length > 0 || user?.company_id;
    if (!hasCompany) {
      return <Navigate to="/no-company" replace />;
    }
  }

  return children;
};